import React, { useEffect } from "react";

export default function CuerpoNoEncontrado() {
  useEffect(() => {
    document.title = "Cuerpo de Bomberos no disponible";
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      background: "#f5f7fa",
      boxSizing: "border-box",
      fontFamily: "Arial, sans-serif",
    }}>
      <div style={{
        width: "100%",
        maxWidth: 720,
        background: "white",
        borderRadius: 18,
        padding: "42px 34px",
        boxShadow: "0 14px 40px rgba(0,0,0,.12)",
        textAlign: "center",
      }}>
        <div style={{ fontSize: 54, marginBottom: 12 }}>🚒</div>
        <h1 style={{ margin: "0 0 14px", fontSize: 30 }}>
          Cuerpo de Bomberos no disponible
        </h1>
        <p style={{ margin: 0, fontSize: 18, lineHeight: 1.5, color: "#4b5563" }}>
          El Cuerpo de Bomberos solicitado no existe, fue eliminado o ya no se encuentra registrado en la plataforma.
        </p>
        <p style={{ marginTop: 18, fontSize: 15, color: "#6b7280" }}>
          Digital Evolution BM
        </p>
      </div>
    </div>
  );
}
